module.exports = __webpack_public_path__ + "static/media/haze.9cc5eb6f.svg";